import * as React from "react";
import { SVGProps } from "react";
const SvgSocialPinterest = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 5C9.925 5 5 9.925 5 16c0 4.661 2.9 8.64 6.99 10.242-.095-.87-.182-2.204.04-3.154l1.289-5.468-.051-.118a4.174 4.174 0 0 1-.277-1.514c0-1.53.886-2.672 1.99-2.672.939 0 1.391.704 1.391 1.549 0 .943-.6 2.355-.91 3.663-.26 1.095.549 1.988 1.628 1.988 1.956 0 3.459-2.062 3.459-5.038 0-2.634-1.893-4.475-4.595-4.475-3.13 0-4.967 2.347-4.967 4.773 0 .946.364 1.96.818 2.511a.33.33 0 0 1 .077.316l-.306 1.248c-.049.201-.16.243-.368.146-1.374-.64-2.233-2.648-2.233-4.261 0-3.47 2.521-6.658 7.268-6.658 3.817 0 6.782 2.72 6.782 6.354 0 3.79-2.39 6.842-5.708 6.842-1.114 0-2.163-.578-2.522-1.263l-.684 2.615c-.25.956-.92 2.153-1.368 2.883 1.03.32 2.123.491 3.257.491 6.075 0 11-4.924 11-11 0-6.075-4.925-11-11-11Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialPinterest;
